<template>
  <div>
    <right-panel class="float-right" id="sidebar-new-data" width="600px" :icon="'mdi mdi-plus'" :text="$t('data.new')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-new-datasubject" width="600px" @hidden="datasubjectRightPanelClosed">
      <div class="pl-5 pr-5">
        <FormDatasubject :hide-library="false" />
      </div>
    </right-panel>

    <h4
      v-if="parentEntity"
      v-html="
        $t('data.owned-list', {
          department: $options.filters.translate(parentEntity.process.department.name),
          process: $options.filters.translate(parentEntity.process.name),
          name: $options.filters.translate(parentEntity.name),
        })
      "
    ></h4>
    <nav class="breadcrumb" v-if="parentEntity">
      <a class="breadcrumb-item" href="/organization">
        {{ $t("organization.text") }}
      </a>

      <a class="breadcrumb-item" :href="`/department-process/${parentEntity.process.department._id}`">
        {{ parentEntity.process.department.name | translate }}
      </a>

      <a class="breadcrumb-item" :href="`/process-datasource/${parentEntity.process._id}`">
        {{ parentEntity.process.name | translate }}
      </a>

      <a class="breadcrumb-item" href="javascript:;">
        {{ parentEntity.name | translate }}
      </a>

      <a class="breadcrumb-item text-muted" href="javascript:;">
        {{ $t("data.plural") }}
      </a>
    </nav>

    <table class="table project-list-table compact ">
      <thead>
        <tr>
          <th style="width:50px"></th>
          <th style="width:300px">
            <sortable-table-head field="name" :text="$t('data.text')" tag="span" :request="request" />
          </th>
          <th style="width:300px">{{ $t("data-category.text") }}</th>
          <th style="width:300px">{{ $t("datasubject.text") }}</th>
          <th style="width: 15%">
            <a href="javascript:;" @click="toggleFilter">
              <span v-if="filterEnabled" class="text-warning">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-hide") }}
              </span>
              <span v-else class="text-muted">
                <i class="bx bxs-filter-alt"></i>
                {{ $t("common.filters-show") }}
              </span>
            </a>
          </th>
        </tr>
        <tr v-if="filterEnabled">
          <th></th>
          <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>

          <th>
            <filter-select
              id="categoryFilter"
              ref="categoryFilter"
              :placeholder="$t('data-category.text')"
              :multiple="false"
              @filter="onCategorySearch"
              @changed="onCategorySelect"
            />
          </th>

          <th colspan="2"></th>
        </tr>
      </thead>
      <template v-if="pagination && pagination.docs.length > 0">
        <tr v-for="item in pagination.docs" :key="item._id" class="hider">
          <td>
            <div class="hidden hand">
              <a v-if="hasUpdatePermission" @click="edit(item)" v-b-toggle="'sidebar-edit-organization-datasource'" v-b-tooltip.hover :title="$t('common.edit')" class="mr-2">
                <i class="bx bx-pencil text-primary"></i>
              </a>

              <a v-if="hasRemovePermission" @click="deleteById(item)" v-b-tooltip.hover :title="$t('common.delete')">
                <i class="bx bx-trash-alt text-danger"></i>
              </a>
            </div>
          </td>

          <td>
            {{ item.data.name | translate }}
          </td>

          <td>
            <span v-if="item.data.category">
              {{ item.data.category.name | translate }}
            </span>
            <span v-else>-</span>
          </td>
          <td colspan="2">
            <datasubject-select :datasourceData="item" class="mr-3" @openPanel="openDatasubjectPanel" />
          </td>
        </tr>
      </template>
    </table>
    <!-- end row -->

    <content-loading v-if="isLoading" />

    <empty v-if="!isLoading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center">
        {{ $t("data.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->

    <div v-if="pagination" class="row mb-5 pb-5">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <div class="mb-5 mt-5 pt-5 pb-5"></div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import FormDatasubject from "@/modules/datasubject/organization-datasubject-form";
import DatasubjectSelect from "@cc/organization-datasubject-select";
import Form from "./organization-datasource-data-form";

export default {
  components: { Form, DatasubjectSelect, FormDatasubject },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      categoryFilter: undefined,
      filterEnabled: false,
    };
  },
  computed: {
    selectedEntity() {
      return this.$store.getters["organizationDatasourceData/selectedEntity"];
    },
    parentEntity() {
      return this.$store.getters["organizationProcessDatasource/selectedEntity"];
    },
    pagination() {
      return this.$store.getters["organizationDatasourceData/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDatasourceData/isLoading"];
    },
    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
  },
  watch: {
    "$route.params.datasource": {
      immediate: true,
      handler() {
        this.fetchParent();
      },
    },
    request: {
      deep: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  mounted() {},
  methods: {
    async fetchParent() {
      this.$store.commit("organizationProcessDatasource/selectedEntity", undefined);
      this.$store.commit("organizationDatasourceData/pagination", undefined);

      const parentId = this.$route.params.datasource;
      if (parentId) {
        await this.$store.dispatch("organizationProcessDatasource/findById", parentId);
      }
      this.paginate();
    },
    async paginate() {
      const request = { ...this.request };
      if (this.parentEntity) {
        request.query = {
          ...request.query,
          datasource: { value: { _id: this.parentEntity._id }, isObject: true },
        };
      }

      await this.$store.dispatch("organizationDatasourceData/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDatasourceData/delete", item._id);
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    edit(item) {
      this.$store.commit("organizationDatasourceData/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-data");
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 15, sort: { name: "asc" } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDataCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      if (item) {
        this.request.query = {
          ...this.request.query,
          category: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["category"] = null;
        delete this.request.query["category"];
      }
    },
    openDatasubjectPanel() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },
    datasubjectRightPanelClosed() {
      this.$store.dispatch("organizationDatasubject/resetForm");
    },
    routerPush(item) {
      this.$router.push("/data-datasource/" + item._id);
    },
    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDatasourceData/editedEntity");
      this.$store.commit("organizationDatasourceData/copingEntity");
      // this.$store.dispatch("organizationDatasourceData/resetForm");
    },
  },
};
</script>
